import { render } from "./discount-detail.vue?vue&type=template&id=12e9106a"
import script from "./discount-detail.vue?vue&type=script&lang=js"
export * from "./discount-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__